import * as z from "zod";
import { hsaAnswer } from "../hsa-answer";
import { hsaOrderContext } from "../hsa-order-context";
import { hsaSessionState } from "./types";

// Stateless: the client holds the answer map in memory and sends the full
// accumulated set each call, so the server walks without persisting anything.
export const getHandoffSurveyGroupInput = z.object({
  sessionToken: z.string().uuid(),
  answers: z.record(z.string(), hsaAnswer),
  // Step-through advance: present = return this step's successor on the
  // active path; absent (initial load) = return the frontier.
  currentStepHandle: z.string().min(1).optional(),
});

// `storefront` lets the client resolve line-item images and variant titles that
// the partner doesn't send. The access token is a public browser token.
const hsaHandoffStorefront_ = z.object({
  storeUrl: z.string().min(1),
  storefrontAccessToken: z.string().min(1),
});
export const hsaHandoffStorefront: z.ZodType<HsaHandoffStorefront> =
  hsaHandoffStorefront_;
export interface HsaHandoffStorefront extends z.infer<
  typeof hsaHandoffStorefront_
> {}

export const getHandoffSurveyGroupOutput = z.object({
  state: hsaSessionState,
  // Both nullable so sessions minted before the rail existed keep working.
  orderContext: hsaOrderContext.nullable(),
  storefront: hsaHandoffStorefront_.nullable(),
});
